import React from 'react';

import { Input, InputGroup, Icon,CheckboxGroup,Checkbox,RadioGroup,Radio } from 'rsuite';

import Config from '../../config/Config'
import Cache from '../../frame/Cache';
import WidgetAjax from '../../widget/WidgetAjax';
import WidgetModal from '../../widget/WidgetModal';
import WidgetTreeTable from '../../widget/WidgetTreeTable';
import WidgetMessage from '../../widget/WidgetMessage';
import WidgetComponent from '../../widget/WidgetComponent';
import WidgetTable from '../../widget/WidgetTable';
import WidgetSelect from '../../widget/WidgetSelect';

import 'antd/dist/antd.css';

class Component extends WidgetComponent
{
    constructor( props )
    {
        super(props);

        let path = Config.getBasePath();

        if( path.endsWith('/')===false )
        {
            path = path + '/';
        }

        this.state = {
            isEdite:true,
            defaultExpandAll:true,
            path : path,
            keyWord : undefined,
            data : undefined,
            total : undefined,
            propotyEdite:{},
            propertyRemove:{},
            checkedKeys :[],
            component:{},
            componentId:undefined,
            parentCpmoentId : undefined,
            parentCpmoentFlag : false,
            options : {
                rowKey : "id",
                defaultExpandAll:false
            },
            columns:[
            //   { name: 'id', title: '组件id', type: 'string', description: '组件id', properties: { hidden: false }},
            //   { name: 'parent_id', title: '父组件id', type: 'string', description: '父组件id', properties: { hidden: false }},
              { name: 'name', title: '组件名称', type: 'string', description: '组件名称', properties: { hidden: false}},
              { name: 'title', title: '组件标题', type: 'string', description: '组件标题', properties: { hidden: false, width:20}},
              { name: 'type', title: '组件类型', type: 'string', description: '组件类型', properties: { hidden: false }},
              { name: 'path', title: '组件路径', type: 'string', description: '组件路径', properties: { hidden: false, width:15}},
              { name: 'accessName', title: '操作权限', type: 'string', description: '操作权限', properties: { hidden: false }},
              { name: 'description', title: '内容', type: 'string', description: '内容', properties: { hidden: false }},
            //   { name: 'captchar', title: '启用状态', type: 'string', description: '启用状态', properties: { hidden: false }},
            //   { name: 'orders', title: '排序', type: 'string', description: '排序', properties: { hidden: false }},
              { name: 'operation', title: '操作', type: 'string', description: '操作', 
                  properties: {hidden: false, width:20, 
                      operations: [
                          { name: '编辑', click: "componentEdit" },
                          { name: '删除', click: "componentRemove"},
                          { name: '添加子组件', click: "addchildren" },
                          { name: '组件接口对应关系', click: "componentMethods"}

                      ]
                  }
              },
              
            ],
            adddata :[],
            propotys:[
                { name: 'properties', title: '名称', type: 'string', description: '名称', properties: { hidden: false }},
                { name: 'description', title: '内容', type: 'string', description: '内容', properties: { hidden: false }},
                { name: 'operation', title: '操作权限', type: 'string', description: '操作', 
                  properties: {hidden: false, 
                      operations: [
                          { name: '编辑', click: "propertyEdit" },
                          { name: '删除', click: "propertyRemove"},
                      ]
                  }
              },
            ],
            editComponentModelOptions : {
                title : "新增组件",
                confirm : "确定",
                size:'md'
            },
            coptions: {
                title:'新增属性',
                confirm:"确定"
            },
            removeGroup : {

            },
            layout : {
                labelCol: { span: 6 },
                wrapperCol: { span: 16 },
            },
            messageOptions : {
                title : "信息",
            },
            typeOptions:{
                title:'组件类型'
            },
            typeData:[
                {label:'PAGE',value:'PAGE'},
                {label:'POPUP',value:'POPUP'},
                {label:'WIDGET',value:'WIDGET'},
            ],
        };
        this.cnewly=this.cnewly.bind(this);
        this.clearall=this.clearall.bind(this);
        this.onEvent = this.onEvent.bind(this);
        this.onhandle=this.onhandle.bind(this)
        this.cOnchange=this.cOnchange.bind(this)
        this.onSelect = this.onSelect.bind(this);
        this.addchildren=this.addchildren.bind(this)
        this.propertyEdit=this.propertyEdit.bind(this)
        this.componentFold=this.componentFold.bind(this)
        this.keyWordKeyUp = this.keyWordKeyUp.bind(this);
        this.propertyRemove=this.propertyRemove.bind(this)
        this.onRemoveConfirm = this.onRemoveConfirm.bind(this); 
        this.inputOnchange = this.inputOnchange.bind(this);
        this.removeConfirm = this.removeConfirm.bind(this);
        this.csubmitProperty=this.csubmitProperty.bind(this)
        this.keyWordOnChange = this.keyWordOnChange.bind(this);
        this.createComponent = this.createComponent.bind(this);
        this.componentRemove = this.componentRemove.bind(this);
        this.submitComponent = this.submitComponent.bind(this);
        this.serchCompontent = this.serchCompontent.bind(this);
        this.onpropertyRemove=this.onpropertyRemove.bind(this)
        this.onserchCompontent = this.onserchCompontent.bind(this);
        this.onSubmitcomponent = this.onSubmitcomponent.bind(this);

        this.editComponent = this.editComponent.bind(this);

        this.buildTreeTableData = this.buildTreeTableData.bind(this);
        this.componentMethods = this.componentMethods.bind(this)
        
    }

    componentDidMount()
    {
        this.serchCompontent(1);
    }

    /**
     * 创建组件弹框
     * @param {*} ref 
     */
    addComponent = (ref) => {

        this.addComponent =  ref ;

        this.addComponent.open();
    }

    messageRef = ( ref ) => {
        this.messageRef = ref;
    }

    caddPropety = (ref) => {
        this.caddPropety=ref
    }

    /**
     * 表格点击事件
     * @param {*} type 
     * @param {*} data 
     * @param {*} value 
     * @param {*} event 
     */
     onEvent(type, data, value, event)
     {
         if( data!==undefined )
         {
             data = data;
         }
 
         switch( type )
         {
             case "addchildren":
             {
                this.addchildren(data);
                break;
             }
             case "componentEdit":
             {
                this.editComponent(data);
                break;
             }
             case "componentRemove":
             {
                this.componentRemove(data);
                break;
             }
             case "componentMethods":
                this.componentMethods(data);
                break;
             default:
                break;
         }
     }

     // 新增属性中的编辑删除
     onhandle(type, data, value, event)
      {
        if( data!==undefined )
        {
            data = JSON.parse(data);
        }
        switch( type )
        {
            case "propertyEdit":
            {
               this.propertyEdit(data);
                break;
            }
            case "propertyRemove":
            {
                this.propertyRemove(data);
                break;
            }
            default:
                break;
        }

      }

      /**
     * 搜索关键字变化回调函数 
     * @param {*} value 
     * @param {*} event 
     */
    keyWordOnChange(value, event)
    {
        this.setState({keyWord:value});
    }

    /**
     * 键盘事件捕获
     * @param {*} e 
     */
    keyWordKeyUp( e )
    {
        /** 判断是否是回车事件 */
        if( e.keyCode===13 )
        {
            this.serchCompontent();
        }
    }

    
 
    /**
     * 组件搜索函数
     */
    serchCompontent()
    {
        const {path, keyWord, options} =this.state;
        
        let params = {
            records:9999999
        }
        if(keyWord!==undefined)
        {
            params['name']=keyWord
        }
        
        WidgetAjax.ajax({url:path+'component/search', params:params, callback:this.onserchCompontent})
    }

    onserchCompontent(result, params)
    {
        let { options }=this.state

        let  target={}, parentId = undefined;

        if(result.status===0)
        {
            let data = [];
            if( result.results!==undefined && result.results.length>0 )
            {
                let buildData = this.buildData(result.results);
                let treeTableData = this.buildTreeTableData(target, buildData, parentId);
 
                data.push(...treeTableData.children);
            }
            
                this.setState({data:data,total:result.total,options:options})

            
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    buildData(data)
    {
        data.forEach(( val, item )=>{
            switch(val.access)
            {
                case 0 :
                {
                    val.accessName = "无";
                    val.accessType = []
                    break;
                }
                case 1 :
                {
                    val.accessName = "执行";
                    val.accessType = [1]
                    break;
                }
                case 2 :
                {
                    val.accessName = "写";
                    val.accessType = [2]
                    break;
                }
            
                case 3 :
                {
                    val.accessName = "执行、写";
                    val.accessType = [1,2]
                    break;
                }
                case 4 :
                {
                    val.accessName = "读";
                    val.accessType = [4]
                    break;
                }
                case 5 :
                {
                    val.accessName = "读、执行";
                    val.accessType = [1,4]
                    break;
                }
                case 6 :
                {
                    val.accessName = "读、写";
                    val.accessType = [2,4]
                    break;
                }
                case 7 :
                {
                    val.accessName = "读、写、执行";
                    val.accessType = [1,2,4]
                    break;
                }
            }
        })
        return data;
    }

    // 
    /**
     * 创建树形表格数据
     * @param {*} target 目标数据 {}
     * @param {*} sources 源数据 数组形式
     * @param {*} parent 父Id
     * @returns 
     */
    buildTreeTableData(target, sources, parentId)
    {
        let children = [];
        for( let item of sources )
        {
            if( item.parent_id===parentId )
            {
                children.push(item)
            }
        }


        if( children!==undefined && children.length>0 )
        {
            target['children']=children
        }
        
        if( target['children']!==undefined && target['children'].length>0)
        {
            for(let item of target['children'])
            {

                this.buildTreeTableData(item, sources, item.id)
            }
        }

        return target;
    }
     
    // 添加子组件
    addchildren(data) 
    {
        this.state["isCreate"] = true;

        this.setState({parentCpmoentFlag:true, parentCpmoentId:data.id, component:{parent:data.name}, adddata:[]});

        this.addComponent.open();
    }

    /**
     * 组件弹框创建
     */
    createComponent()
    {

        this.setState({ parentCpmoentFlag:false });   //添加组件时候不需要添加父组件

        this.state["isCreate"] = true;

        this.setState({component:{}, componentId:undefined, parentCpmoentId:undefined});

        this.addComponent.open();
    }

    /**
     * 编辑组件
     */
    editComponent( data )
    {
        const {editComponentModelOptions}=this.state

        this.state["isCreate"] = false;
        
        if( data!==undefined )
        {
            let adddata = [];

            if( data.properties!==undefined && data.properties!==null )
            {
                for(let key in data.properties)
                {
                    adddata.push({properties:key, description:data.properties[key]});
                }               
            }

            this.setState({component:data, componentId: data.id,parentCpmoentId:data.parent_id, adddata:adddata});
        }

        editComponentModelOptions['title']='编辑组件'

        this.addComponent.open();
    }


    /**
     * 创建组件回调
     * @param {*} result 
     * @param {*} params 
     */
     onSubmitcomponent( result, params )
    {
        let { messageOptions, isCreate } = this.state;

        messageOptions["isMessage"] = true ;
        if( result.status===0 )
        {
            if( isCreate )
            {
                messageOptions["message"] = "组件 '" + params.name +"' 创建成功！" ;

                setTimeout(()=>{
                    window.location.reload();
                },1000)

            }
            else
            {
                messageOptions["message"] = "组件 '" + params.name +"' 修改成功！" ;

                setTimeout(()=>{
                    window.location.reload();
                },1000)

            }

            this.serchCompontent();

            this.messageRef.open();
        }
        else
        {
            if( isCreate )
            {
                messageOptions["message"] = "组件创建失败！'"+result.message+"'" ;
            }
            else
            {
                messageOptions["message"] = "组件修改失败！'"+result.message+"'" ;
            }
         this.messageRef.open();
        }
    }
    
   
    // 新增中新增属性的单击事件
    cnewly()
    {
        this.caddPropety.open()
        this.state['isEdite']=true
    }

    // 新增属性编辑
    propertyEdit(data) 
    {
        this.state['isEdite']=false
        if(data!==undefined){
           this.setState({propotyEdite:data})
        }
        
        this.caddPropety.open()
        
    }

    // 新增属性删除
    propertyRemove(data) 
    {
        let  messageOptions = {
            title : "信息",
            isMessage : false
        };
        messageOptions["message"]='你确定要删除吗'
        messageOptions["confirmFunction"] = this.onpropertyRemove;
        this.state['propertyRemove']=data
        this.setState({messageOptions:messageOptions});

        this.messageRef.open();
    }

    onpropertyRemove() 
    {
        const {propertyRemove, adddata}=this.state
        
        adddata.splice(propertyRemove, 1);
        
        this.setState({adddata:adddata});
        
    }

     // 组件属性的新增onchange事件
     cOnchange( value, type )
     {
         switch( type )
         {
             case "cattribute":
             {
                 this.state["cattribute"] = value;
                 break;
             }
             case "content":
             {
                this.state["content"] = value;
             }
             default:
                 break
         }
     }
 
     // 新增中新增属性的确定
    csubmitProperty () {

         const { cattribute, content, adddata,isEdite }=this.state;
        
         // 判断是编辑还是新增
         if(isEdite)
         {
            let params= {

                properties:cattribute,
   
                description:content
   
            }
    
            adddata.push(params);
            
            this.setState({adddata:adddata});
         }
         else
         {
            const { propotyEdite}=this.state

            for(let i=0;i<adddata.length;i++){
               if(adddata[i].serial===propotyEdite.serial){
                    adddata[i].properties=cattribute
                    adddata[i].description=content
               }
               this.setState({adddata:adddata});
           }
         }
         
     }
 

    // 下拉菜单的select
    onSelect(value, item, event)
    {
        this.setState({component:{...this.state.component, type:value}}) ;
    }
    /**
     * 删除角色
     * @param {*} data 
     */
     componentRemove( data )
    {

        let { messageOptions } = this.state;

        messageOptions["isMessage"] = false ;
        messageOptions["message"] = `确定要删除组件 '` + data.name +`' 吗? 删除后将不能恢复！` ;
        messageOptions["confirmFunction"] = this.removeConfirm;
        
        this.state["componentRemove"] = data;

        this.state["messageOptions"] = messageOptions;

        this.messageRef.open();
    }

    /**
     * 删除确认函数
     */
    removeConfirm()
    {
        const { path, componentRemove } = this.state;

        if( componentRemove!==undefined )
        {
            let params = {
                id : componentRemove.id
            }
    
            WidgetAjax.ajax({url:path + 'component/remove', params:params, callback:this.onRemoveConfirm});
        }
    }

    /**
     * 组件删除回调函数
     * @param {*} result 
     * @param {*} params 
     */
    onRemoveConfirm( result, params )
    {
        let  messageOptions = {
            title : "信息",
            isMessage : true
        };

        if( result.status===0 )
        {
            messageOptions["message"] = "组件 '" + params.id +"' 删除成功！" ;

            setTimeout(()=>{
                window.location.reload();
            },1000)
        }
        else
        {
            messageOptions["message"] = "组件 '" + params.id +"'" + result.message +"" ;
        }

        this.state["messageOptions"] = messageOptions;
        
        this.serchCompontent();

        this.messageRef.open();
    }

    /**
     * 清空
     */
    clearall(){
        let { adddata } = this.state;

        adddata = [];

        this.setState({adddata:adddata})
    }

    //折叠
    componentFold() 
    {
        let { options } = this.state;

        options['defaultExpandAll']=false;

        this.setState({options:options});
    }

    /**
     * 创建组件
     */
    submitComponent()
    {
        const { adddata, coperation, cattribute, path, 
                 isCreate, component, componentId, parentCpmoentId, parentCpmoentFlag,
                 content, crsc, messageOptions} = this.state;
        let access = 0;

        //各个选项的非空校验
        if(component.title === "" || component.title === undefined || component.title === null)
        {
            messageOptions.isMessage = true;
            messageOptions.message = "组件标题不能为空！";
            this.setState({messageOptions},()=>{
                this.messageRef.open()
            })
            return;
        }
        else if(component.name === "" || component.name === undefined || component.name === null)
        {
            messageOptions.isMessage = true;
            messageOptions.message = "组件名称不能为空！";
            this.setState({messageOptions},()=>{
                this.messageRef.open()
            })
            return;
        }
        else if(component.type === "" || component.type === undefined || component.type === null)
        {
            messageOptions.isMessage = true;
            messageOptions.message = "请选择组件类型！";
            this.setState({messageOptions},()=>{
                this.messageRef.open()
            })
            return;
        }
        else if(component.accessType === [] || component.accessType === undefined || component.accessType === null)
        {
            messageOptions.isMessage = true;
            messageOptions.message = "请选择操作权限！";
            this.setState({messageOptions},()=>{
                this.messageRef.open()
            })
            return;
        }
        else if(component.captchar === undefined || component.captchar === null)
        {
            messageOptions.isMessage = true;
            messageOptions.message = "请选择反爬虫控制权限！";
            this.setState({messageOptions},()=>{
                this.messageRef.open()
            })
            return;
        }

        if(component.accessType === undefined || component.accessType === null || component.accessType  === [])
        {
            access = 0
        }
        else
        {
            component.accessType.forEach((val,index)=>{
                access+=val
            })
        }

        let properties = {};

        for(let item of adddata)
        {
            properties[item.properties] = item.description;
        }

        let params = {
            name:component.name,
            title:component.title,
            type:component.type,
            captchar:component.cradios,
            description:component.description,
            access:access,
            properties:properties
        }

        let filter =  /[^\u0000-\u00FF]/

        if(!filter.test(component.path)){
            params["path"] = component.path
        }else{

            messageOptions.isMessage = true;

            messageOptions.message = "请输入正确路径！";

            this.setState({messageOptions},()=>{
                this.messageRef.open()
            })

            return ;
        }
 
         if(coperation!==undefined && coperation.length>0 )
         {
             let num=0
 
             for (let i=0; i<coperation.length; i++)
             {
              num= num+parseInt(coperation[i]);
             }
             params['access']=num
         }
         
         // 判断是否是编辑，如果是编辑，将id和parent——id传入
         if(component!==undefined && Object.keys(component).length>0 && (componentId !== undefined || parentCpmoentId !==undefined))
         {
             params['id']=componentId
             params['parent_id']=parentCpmoentId
             params['path']=component.path
         }
        
         if( isCreate )
         {
             if( parentCpmoentFlag )
             {
                 params['parent_id']=parentCpmoentId;
             }
             else
             {
                 params['parent_id']=undefined;
             }
             WidgetAjax.ajax({url:path + 'component/create', params:params, callback:this.onSubmitcomponent});
         }
         else
         {
             WidgetAjax.ajax({url:path + 'component/update', params:params, callback:this.onSubmitcomponent});
         }
         
         
     }
 
    // 新增的input change事件
    inputOnchange( value, type )
    {
        let { component } = this.state;

        switch( type )
        {
            case "cname":
            {
                this.state["component"] = {...component,name:value};
                break;
            }
            case "ctitle":
            {
                this.state["component"] = {...component,title:value};
                break;
            }
             case "ctype":
            {
                this.state["component"] = {...component,type:value};
                break;
            }
             case "csrc":
            {
                this.state["component"] = {...component,path:value};
                break;
            }
            case "cradios":
           {
               this.state["component"] = {...component,captchar:value};
               break;
           }
           case "coperation":
           {
               this.state["component"] = {...component,accessType:value};
               break;
           }
           case "cdescribe":
           {
               this.state["component"] = {...component,description:value};
               break;
           }
           default:
               break;
            //  case "cradio":
            // {
            //     this.state["component"] = {...component,cradio:value};
            //     break;
            // }
            //  case "cstort":
            // {
            //     this.state["component"] = {...component,cstort:value};
            //     break;
            // }
            //  case "cicon":
            // {
            //     this.state["component"] = {...component,cicon:value};
            //     break;
            // }
        }
    }

    componentMethods( data )
    {
        this.props.history.push({pathname:'/home/Method', state:{department:data}});
    }
    
    render()
    {
        const { columns, data,adddata, checkedKeys, keyWord, options, editComponentModelOptions, propotys, coptions,
             messageOptions,typeOptions,typeData, component,propotyEdite,isCreate,parentCpmoentFlag} = this.state;
             
        editComponentModelOptions["confirmFunction"] = this.submitComponent;
        coptions["confirmFunction"]=this.csubmitProperty

        return (
            <div className="page ">
                {/* <div className="page-weidu">
                    <div className="page-title">
                        <div className="page-title-img"><img src={require("./img/ml-ztzt.png")} alt=""></img></div>
                        <span className="page-title-font">组件管理</span>
                    </div>
                </div> */}
                
                <div className="page-content page-overflow" style={{height:"100%"}}>
                    <div className="content-canvas content-top-frame-height height-100">
                        <div className="content-title Addroles" style={{padding:"0 16px"}}>
                            <div className="button btnleft" onClick={this.createComponent}>
                                <span>新增组件</span>
                            </div>
                            {/* <div className="button">
                                <span onClick={this.componentFold}>折叠</span>
                            </div> */}
                            <div className="search">
                                <InputGroup className="InputGroup"  >
                                    <Input name="Serchkey" defaultValue={keyWord} placeholder="请输入搜索内容" onChange={this.keyWordOnChange } onKeyUp={this.keyWordKeyUp} />
                                    <InputGroup.Addon><Icon icon="search" onClick={this.serchCompontent} /></InputGroup.Addon>
                                </InputGroup>
                            </div>
                        </div>

                        <div className="content-chart-height content-table" style={{height:'calc(100% -  56px)'}}>
                            <WidgetTreeTable options={options}  columns={columns} data={data} checkData={checkedKeys} onCheck={this.onCheck} notify={this.onEvent}></WidgetTreeTable>
                        </div>
                    </div>
                </div>

                <WidgetModal options={editComponentModelOptions} onRef={this.addComponent} >
                    <table>
                        <tbody>
                            <tr style={isCreate && parentCpmoentFlag ? { display:'block' } : { display:'none' }}>
                                <td>上级菜单</td>
                                <td><Input defaultValue={component.parent} disabled/></td>
                            </tr>
                            <tr className="level">
                                <td>组件名称</td>
                                <td><Input defaultValue={component.name} onChange={(value) => {this.inputOnchange(value, "cname")}} placeholder="请输入组件名称"/></td>
                            </tr>
                            <tr className="level">
                                <td>组件标题</td>
                                <td><Input defaultValue={component.title} onChange={(value) => {this.inputOnchange(value, "ctitle")}} placeholder="请输入组件标题"/></td>
                            </tr>
                            
                            <tr className="level">
                                <td>组件类型</td>
                                <td style={{paddingLeft:"5px"}}><WidgetSelect defaultValue={component.type}  onSelect={this.onSelect} options={typeOptions}  data={typeData}></WidgetSelect></td>
                            </tr>
                            <tr className="level">
                                <td>组件路径</td>
                                <td><Input defaultValue={component.path} onChange={(value) => {this.inputOnchange(value, "csrc")}} placeholder="请输入组件路径"/></td>
                            </tr>
                            <tr className="level">
                                {/* <td>启用状态</td>
                                <td>
                                <RadioGroup name="radioList" defaultValue={component.cradio} inline onChange={(value) => {this.inputOnchange(value, "cradio")}}>
                                    <Radio value = {true}>启用</Radio>
                                    <Radio value = {false}>停用</Radio>
                                </RadioGroup>
                                </td> */}
                                
                                <td>操作权限</td>
                                <td>
                                <CheckboxGroup onChange={(value) => {this.inputOnchange(value, "coperation")}}
                                    defaultValue={component.accessType}
                                    inline
                                    name="checkboxList"
                                    value={this.state.value}
                                    >
                                    <Checkbox value={4}>读</Checkbox>
                                    <Checkbox value={2}>写</Checkbox>
                                    <Checkbox value={1}>执行</Checkbox>
                                </CheckboxGroup>
                                </td>

                                <td>反爬虫控制</td>
                                <td>
                                <RadioGroup name="radioList" defaultValue={component.captchar} inline onChange={(value) => {this.inputOnchange(value, "cradios")}}>
                                    <Radio value={true}>启用</Radio>
                                    <Radio value={false}>停用</Radio>
                                </RadioGroup>
                                </td>
                            </tr>
                            {/* <tr className="level">
                                <td>组件顺序</td>
                                <td><Input placeholder="请输入0-999位组件排序" defaultValue={component.cstort} onChange={(value) => {this.inputOnchange(value, "cstort")}}/></td>
                                <td>图标名称</td>
                                <td>
                                    <Input text="textarea" placeholder="请输入图标名称(英文名)" defaultValue={component.cicon} onChange={(value) => {this.inputOnchange(value, "cicon")}}/>
                                </td>
                            </tr> */}
                            <tr className="level">
                                
                            </tr>
                            <tr className="level">
                                <td>组件内容</td>
                                <td><Input text="textarea" placeholder="请输入组件内容" defaultValue={component.description} onChange={(value) => {this.inputOnchange(value, "cdescribe")}}/></td>
                                
                            </tr>
                            <tr className="level">
                                <td>组件属性</td>
                                <td>
                                    <div className="Addroles" style={{justifyContent:"left"}}>
                                        <button onClick={this.cnewly}>新增</button>
                                        <button onClick={this.clearall}>清空</button>
                                    </div>
                                    <WidgetTable defaultValue={component.properties} options={options} columns={propotys} data={adddata} total={adddata.length} notify={this.onhandle} pageTurning={this.pageTurning} WidgetTableHeight={true}></WidgetTable>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </WidgetModal>
                <WidgetModal options={coptions} onRef={this.caddPropety} >
                     <table>
                         <tbody>
                            <tr>
                                <td>名称</td>
                                <td><Input onChange={(value) => {this.cOnchange(value, "cattribute")}} defaultValue={propotyEdite.properties}  placeholder="请输入属性名称"/></td>
                            </tr>
                            <tr>
                                <td>内容</td>
                                <td><Input onChange={(value) => {this.cOnchange(value, "content")}} defaultValue={propotyEdite.description} placeholder="请输入内容"/></td>
                            </tr>
                        </tbody>
                     </table>
                </WidgetModal>
                <WidgetMessage options={messageOptions} onRef={this.messageRef} />
          </div>
        );
    }
}

export default Component


